import React from 'react'
import { Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useGetBusinessID } from '@marketing-milk/frontend'
import { useScreenSize } from 'hooks/useScreenSize'
import { RecentImportsMenu } from './RecentImportsMenu'

export const CreativeImportButton = () => {
  const { isMobile } = useScreenSize()
  const history = useHistory()
  const businessID = useGetBusinessID()

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => history.push(`/${businessID}/creatives/import`)}
      >
        {isMobile ? '⬆' : 'Import Ads'}
      </Button>
      <RecentImportsMenu />
    </>
  )
}
